<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['anno'],
  data: () => ({
    chartdata: {
      datasets: [
        {
              label: 'Tensione di rete',
              type: 'line',
              showLine: true,
              fill: true,
              steppedLine: true,
              backgroundColor: '#cc0000',
              borderColor: '#cc0000',
              borderWidth: 1
              //data: new Array(366).fill(230)
            },
        {
              label: 'Tensione di rete',
              type: 'line',
              showLine: true,
              fill: true,
              steppedLine: true,
              backgroundColor: '#444444',
              borderColor: '#444444',
              borderWidth: 1,
              //data: new Array(366).fill(230)
        }   
        ]
    },
    options: {
     legend: {
       display:true, 
       align:"end",
       position:"top",
       labels: {
                fontColor: '#000000',
                fontSize: 10,
                boxWidth:25,
                padding:10,
                margin:30
            }
       },
     scales: {
			yAxes: [{
            
						ticks: {
              beginAtZero: true,
              max: 280,
              min: 0,
              stepSize: 40
						},
						gridLines: {
							display: true
						}
					}],
			xAxes: [{
						/*ticks: {
              beginAtZero: true,
              display:true
						},
						gridLines: {
							display: true
            }*/
            type: 'time',
            time: {unit: 'day', displayFormats:{day: 'DD-MM-YY'}},
            distribution: 'linear'
					}]
				},
     responsive: true,
     maintainAspectRatio: false

    }
  }),
  watch: {
    anno: function(newVal,oldVal) {
      console.log("anno cambiato da " + oldVal + " a " + this.anno);
      this.buildChart();
    }
  },
  methods: {
    buildChart() {

      let self = this;

      this.chartdata.datasets = [];
  

      console.log("Grafico eventi, anno:" + this.anno);
      var endDate = this.moment(new Date()).startOf('month').add(1,'months');
      if (this.anno != '') {
        endDate = this.moment(''+(parseInt(this.anno)+1)+'-01-01','YYYY-MM-dd').startOf('year');
      }
      console.log("end date=" + endDate.format('DD-MM-YYYY'));
      var startDate = this.moment(endDate).subtract(12,'months');
      console.log("intervallo = " + startDate.format('DD-MM-YYYY') + " ... " + endDate.format('DD-MM-YYYY'));


      //filtra gli eventi di rete (assenza o rientro rete) 
      var mainEventSorted = this.$store.state.currentLogbooks.filter(function(item) {
        if (item.log_timestamp == null || isNaN(item.log_timestamp)) {
          //console.log("ignoro log centrale " + item.cu_id + ", timestamp:" + item.log_stimestamp);
          return false;
        }
        var data = self.moment(item.log_timestamp*1000);
        if (data.isSameOrAfter(endDate) || data.isBefore(startDate)) return false;
        return (item.log_type == "assenza_rete" || item.log_type == "rientro_rete");
      });
    
      //ordina gli eventi di rete  per data (ultimo il più recente)
      mainEventSorted.sort(function(a, b) {
        if (a.cu_id != b.cu_id) return (''+a.cu_id).localeCompare(b.cu_id);
        return a.log_timestamp - b.log_timestamp;
      });
      console.log("mainEventSorted: ", mainEventSorted);

     this.chartdata.datasets = [];
     var prevCu_id = "";
     var datasetIndex = -1;

  
     for (var k=0; k<mainEventSorted.length; k++) {

        let lb = mainEventSorted[k];
        let cu_id = lb.cu_id;
        let cu_type =lb.log_system;
        let cu_desc="";
        if(lb.cu_desc){
          cu_desc=lb.cu_desc;
        };

        let dataLog = this.moment(lb.log_timestamp*1000);
        
        //console.log("log " + dataLog.format('DD-MM-YYYY')+" index=" + dataIndex);

        let colors = ['#00ff00','#000099','#003366','#CC3333','#669966','#0066ff','#888888','#FF00FF','#FFCC00','#66FF33'];
    

        //this.chartdata.labels[k]

        if (cu_id != prevCu_id) {

            if (prevCu_id != "") {
              var lastval = this.chartdata.datasets[datasetIndex].data[this.chartdata.datasets[datasetIndex].data.length-1].y;
              this.chartdata.datasets[datasetIndex].data.push({x: endDate, y:lastval});
            }

            prevCu_id = cu_id;
            datasetIndex++;
            this.chartdata.datasets.push({
                label: cu_type + ' ' + cu_id,
                type: 'line',
                showLine: true,
                fill: false,
                steppedLine: true,
                backgroundColor: colors[datasetIndex % 10],
                borderColor: colors[datasetIndex % 10],
                pointBorderWidth: 0,
                pointRadius: 0,
                borderWidth: 1,
                //data: [{x:'2019-06-18',y:230},{x:'2020-03-07',y:0},{x:'2020-03-08',y:230},{x:'2020-04-27',y:0},{x:'2020-04-29',y:230},{x:'2020-05-18',y:230}]
                data: []

            });
            

            if (lb.log_type == 'assenza_rete') {
              this.chartdata.datasets[datasetIndex].data.push({x: startDate.format('YYYY-MM-DD') , y:230});
            } else {
              this.chartdata.datasets[datasetIndex].data.push({x: startDate.format('YYYY-MM-DD') , y:0});
            }

        }

        if (lb.log_type == 'assenza_rete') {
          this.chartdata.datasets[datasetIndex].data.push({x: dataLog.format('YYYY-MM-DD') , y:230});
        } else {
          this.chartdata.datasets[datasetIndex].data.push({x: dataLog.format('YYYY-MM-DD') , y:0});
        }


    }

    var lastval = this.chartdata.datasets[datasetIndex].data[this.chartdata.datasets[datasetIndex].data.length-1].y;
    this.chartdata.datasets[datasetIndex].data.push({x: endDate, y:lastval});


    
    this.renderChart(this.chartdata, this.options)

    //console.log("functPlantLogbook: ", functLogbookPlant);
    console.log("chartData:",this.chartdata);
    }
  },
  mounted () {
    console.log("chart mounted");
    window.setTimeout(this.buildChart,100);
  }

}
</script>